import React from 'react';
import { Section } from './ui/Section';
import { HelpCircle } from 'lucide-react';
export function PainPoints() {
  const questions = ['Am I even taking these correctly?', 'Can I mix these together?', 'Should I take this with food or on an empty stomach?', 'Why am I spending money and not seeing results?'];
  return <Section className="bg-white rounded-3xl shadow-sm border border-sage-light/30 my-12" data-id="element-113">
      <div className="max-w-3xl mx-auto" data-id="element-114">
        <p className="text-xl md:text-2xl font-serif text-center mb-10 text-primary-dark" data-id="element-115">
          If you’ve ever looked at your supplement cabinet and thought:
        </p>

        <div className="space-y-4 mb-12" data-id="element-116">
          {questions.map((q, i) => <div key={i} className="flex items-start gap-4 bg-cream-dark/30 p-5 rounded-xl" data-id="element-117">
              <HelpCircle className="text-primary shrink-0 mt-1" size={24} data-id="element-118" />
              <p className="text-lg font-medium italic text-charcoal/90" data-id="element-119">
                "{q}"
              </p>
            </div>)}
        </div>

        <div className="text-center space-y-6 text-lg text-charcoal/80" data-id="element-120">
          <h3 className="text-3xl font-serif text-primary mb-6" data-id="element-121">
            You are not alone.
          </h3>
          <p data-id="element-122">
            Every day, thousands of people buy vitamins, minerals, probiotics,
            and other supplements hoping to feel better, have more energy,
            improve sleep, strengthen immunity, or support long-term health...
          </p>
          <p className="font-medium text-charcoal" data-id="element-123">
            But most people are never taught how to actually use supplements the
            right way.
          </p>
          <div className="bg-primary/5 p-8 rounded-2xl mt-8 text-left space-y-3" data-id="element-124">
            <p data-id="element-125">So they guess.</p>
            <p data-id="element-126">They take everything at once.</p>
            <p data-id="element-127">They combine supplements that should be separated.</p>
            <p data-id="element-128">They buy low-quality products full of fillers.</p>
            <p className="font-semibold text-primary-dark pt-4 border-t border-primary/10 mt-4" data-id="element-129">
              And then they wonder why nothing seems to change.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}